import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import { StyledTag } from './ReportChat.styled';

const StyledStaffTagsContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 5px;
	position: relative;
`;

const StyledStaffTag = styled(StyledTag)`
	background: rgba(255, 255, 255, 0.1);

	${Text} {
		color: #ffffff;
	}
`;

const StyledTooltipContainer = styled.div`
	position: absolute;
	top: 100%;
	left: 0;
	margin-top: 5px;
	padding: 5px 8px;
	background: rgba(0, 0, 0, 0.9);
	border-radius: 5px;
	white-space: nowrap;
	z-index: 1000;
	display: none;

	${StyledStaffTagsContainer}:hover & {
		display: block;
	}

	${Text} {
		font-weight: 400;
		font-size: 11px;
		color: #ffffff;
	}
`;

export { StyledStaffTag, StyledStaffTagsContainer, StyledTooltipContainer };
